export default "__VITE_ASSET__CAoKMy2A__"